// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Billing page components
import RetailerAvatar from "layouts/retailerAvatars/components/RetailerAvatar";

import team1 from "assets/images/team-1.jpg"

import team2 from "assets/images/team-2.jpg"

function AvatarsList({avatars, onViewClick}) {

  function getActionsFormatted(actions){

    let openAplication = 0
    let scannedQR = 0
    let completedSurv = 0
    let successOffers = 0

    for(var i=0;i<actions.length;i++){
      if(actions[i]["action_name"] === "Open Application"){
        openAplication = actions[i]["action_summary"]
      }
      if(actions[i]["action_name"] === "Completed Surveys"){
        completedSurv = actions[i]["action_summary"]
      }
      if(actions[i]["action_name"] === "Successful Offers"){
        successOffers = actions[i]["action_summary"]
      }
      if(actions[i]["action_name"] === "Scanned QR's"){
        scannedQR = actions[i]["action_summary"]
      }
    }
    
    return [
      {
        "action_name": "Open Application",
        "action_summary": openAplication
      },
      {
        "action_name": "Scanned QR's",
        "action_summary": scannedQR
      },
      {
        "action_name": "Visits to my shops",
        "action_summary": 23
      },
      {
        "action_name": "Visits to other shops",
        "action_summary": 12
      },              
      {
          "action_name": "Completed Surveys",
          "action_summary": completedSurv
      },
      {
          "action_name": "Successful Offers",
          "action_summary": successOffers
      },
      {
        "action_name": "Dwell time(m)",
        "action_summary": 15
      },  
    ]
  }


  return (
    <Card id="retailer-avatars">
      <MDBox pt={1} pb={2} px={2}>
        <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {avatars.map((avatar) => (
              <RetailerAvatar
              key={avatar["id"]}
              photoId={avatar["photo_id"]}
              nickname={avatar["nickname"]}
              level={avatar["level"]}
              balance={avatar["balance"]}
              actions={getActionsFormatted(avatar["totals"])}
              onViewClick={() => {onViewClick(avatar)}}
            />

          ))}
          <RetailerAvatar
              key={"avatar0"}
              staticPhoto={true}
              photoId={team2}
              nickname={"AlexPhoenix"}
              level={3}
              balance={1400}
              actions={[
                {
                    "action_name": "Open Application",
                    "action_summary": 280
                },
                {
                  "action_name": "Scanned QR's",
                  "action_summary": 90
                },
                {
                  "action_name": "Visits to my shops",
                  "action_summary": 12
                },
                {
                  "action_name": "Visits to other shops",
                  "action_summary": 30
                },             
                {
                    "action_name": "Completed Surveys",
                    "action_summary": 16
                },
                {
                    "action_name": "Successful Offers",
                    "action_summary": 57
                },
                {
                  "action_name": "Dwell time(m)",
                  "action_summary": 20
                },   
            ]}
              onViewClick={onViewClick}
            />
          <RetailerAvatar
              key={"avatar1"}
              photoId={team1}
              staticPhoto={true}
              nickname={"ElenaShadow"}
              level={3}
              balance={2753}
              actions={[
                {
                    "action_name": "Open Application",
                    "action_summary": 456
                },
                {
                  "action_name": "Scanned QR's",
                  "action_summary": 140
                },
                {
                  "action_name": "Visits to my shops",
                  "action_summary": 6
                },
                {
                  "action_name": "Visits to other shops",
                  "action_summary": 22
                },    
                {
                    "action_name": "Completed Surveys",
                    "action_summary": 24
                },
                {
                    "action_name": "Successful Offers",
                    "action_summary": 45
                },
                {
                  "action_name": "Dwell time(m)",
                  "action_summary": 33
                },             
            ]}
              onViewClick={onViewClick}
            />
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default AvatarsList;
